export class ValidateUtils {
  static requiredErrorMessage = 'This field is required';
  static emailErrorMessage = 'Invalid email format';
  static passwordErrorMessage = 'Must contain a number, an uppercase letter, and a special character';
  static phoneErrorMessage = 'Invalid phone format';
  static bicSwiftErrorMessage = 'BIC/Swift code is invalid';
  static noSpacesErrorMessage = 'This field must not contain spaces';
  static formFieldErrorMessage = 'Incorrect value';

  static emailRegex = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
  static passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?]).+$/;
  static phoneRegex = /^s*-?[0-9]{6,11}s*$/;
  static noSpacesRegex = /^\S*$/;
  static bicCodeRegex = /^([a-zA-Z]){6}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/;
  static formFieldRegex = /[a-zA-Z0-9/-?:().,'+ ]+$/;

  static validateEmail = (value?: string) => {
    if (!value) return false;
    return new RegExp(this.emailRegex).test(value);
  };

  static validatePhoneNumber = (value?: string) => {
    if (!value) return false;
    return new RegExp(this.phoneRegex).test(value);
  };

  static validateFormField = (value?: string) => {
    if (!value) return false;
    const isValid = new RegExp(this.formFieldRegex).test(value);
    return isValid;
  };

  static validateBicCodeField = (value?: string) => {
    if (!value) return false;
    const isValid = new RegExp(this.bicCodeRegex).test(value);
    return isValid;
  };

  static validateFields = (value: string, name: string) => {
    if (!value) return undefined;
    const isFieldValid = ValidateUtils.validateFormField(value);
    return isFieldValid
      ? undefined
      : `${name} contains invalid characters. Please include only letters (a-z, A-Z), numbers (0-9), spaces and special characters /-?:().,'+`;
  };
}
